import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { json } from 'react-router-dom'

const ReduxThunk = () => {
    let dispatch=useDispatch()
    let se=useSelector((state)=>state.store3)
    console.log(se);

    let [i,seti]=useState(1)
        let fetchData=(dispatch,getState)=>{
        let ajax=new XMLHttpRequest()
        ajax.open("GET",`https://jsonplaceholder.typicode.com/users/${i}`)
        ajax.onload=()=>{
            let data=JSON.parse(ajax.response)
            dispatch({type:"add",payload:data})
        }
        ajax.send()
    }

  return (
    <div style={{marginLeft:"50px"}}>
        <div>
            ID:-{se.userData.id}<br />
           name:- {se.userData.name} <br />
           email:- {se.userData.email} <br />
           phone number:- {se.userData.phone}
        </div>
        <div style={{width:"30%",display:"flex",justifyContent:"space-between"}}>
        <button className='btn btn-primary' onClick={()=>{
            seti(i+1)
            dispatch(fetchData)
        }}>INCRESE</button>
        <button className='btn btn-primary' onClick={()=>{
            dispatch(fetchData)
            seti(i-1)
        }}>DECREASE</button>
        </div>
    </div>
  )
}

export default ReduxThunk